import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VOverlay,{attrs:{"color":"iq_dark","value":_vm.loading}},[_c(VIcon,{attrs:{"color":"iq_light","x-large":""}},[_vm._v("mdi-loading mdi-spin")]),_c('span',{staticClass:"iq_light--text font-weight-bold"},[_vm._v(" Loading ")])],1),_c('div',{staticClass:"container"},[(!_vm.loading)?_c(VBtn,{staticClass:"vertical-center",attrs:{"color":"primary"},on:{"click":function($event){return _vm.goToCheckoutLink()}}},[_vm._v(" Checkout with Stripe ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }